<template>
  <div class="m750">
    <div class="navigation" v-if="listSeason.length>1">
      <div class="nav_item" v-for="(item,index) in listSeason" :key="index" @click="checkNav(index)" :class="{'nav_checked':tabIndex==index}">
        {{item}}
      </div>
      <!-- <div class="nav_item" @click="checkNav(2)" :class="{'nav_checked':tabIndex==2,'nav_none':id==1}">
        Moto2
      </div>
      <div class="nav_item" @click="checkNav(3)" :class="{'nav_checked':tabIndex==3,'nav_none':id==1}">
        Moto3
      </div>
      <div class="nav_item" @click="checkNav(4)" :class="{'nav_checked':tabIndex==4,'nav_none':id==1}">
        MotoE
      </div> -->
    </div>
    <div class="main" :class="listSeason.length<=1?'main2':''">
      <div class="item" v-if="list.length>0">
        <div class="item_main" v-for="(item,index) in list" :key="index">
          <div class="item_left">{{item.rank}}</div>
          <div class="item_center">
            <img class="item_people" @error="defaultImgs" :src="item.driver_img" alt="">
            <div class="item_news">
              <div class="news_top">
                <!-- <div class="name" v-if="item.chinese_name&&item.chinese_name.indexOf('·')>-1">{{item.chinese_name.split('·')[0]+'  ·  '+item.chinese_name.split('·')[1]}}</div>
                <div class="name" v-else-if="item.chinese_name&&item.chinese_name.indexOf('·')<=-1">{{item.chinese_name}}</div>
                <div class="name enname" v-else>{{item.rider_name}}  ·  {{item.rider_surname}}</div> -->
                <div class="name">{{item.driver_name}}</div>
                <div class="grade">
                  <div>{{parseInt(item.source)}}</div>
                  <div class="fen">分</div>
                </div>
              </div>
              <div class="news_center">
                <img class="news_country"  @error="defaultImgs2" :src="item.driver_national_flag_img" alt="">
                <div class="news_number">{{item.driver_car_number}}</div>
              </div>
              <div class="news_bottom">{{item.driver_term_name}}</div>
            </div>
          </div>
          <div class="item_right"></div>
        </div>
        <div class="kong"></div>
      </div>
      <div class="item" v-else>
        <div class="noList">
          <img class="nodata" src="https://images.zhibo.tv/2021/0827/nodata.png" alt="">
          <div class="nodata2">暂无内容</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tabIndex: 0,
      list:[],
      defaultImg: 'https://images.zhibo.tv/2021/0827/default_player.png',
      defaultImg2: 'https://images.zhibo.tv/2021/0827/default_country.png',
      id:'',
      listSeason:[],
      listTeam:[]
    }
  },
  created(){
    try {
      window.webkit.messageHandlers.changeTitle.postMessage('世界排名')
    } catch (e) {
      window.console.log(0)
    }
    try {
      window.LiveAppJS.changeTitle('世界排名')
    } catch (e) {
      window.console.log(1)
    }
    this.id = this.$route.query.id
    this.getmotoGp()
  },
  methods: {
    defaultImgs (e) {
      e.target.src = this.defaultImg
      e.target.onerror = null // 防止闪图
    },
    defaultImgs2 (e) {
      e.target.src = this.defaultImg2
      e.target.onerror = null // 防止闪图
    },
    checkNav (index) {
      this.tabIndex = index
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      // this.getmotoGp()
      let current = this.listSeason[index]
      window.console.log(this.listTeam[current])
      this.list = this.listTeam[current]
    },
    // 排行榜信息
    async getmotoGp(){
      // type_id
      let params = {
        season_id: this.id
      }
      let res = await this.$api.getnewmotoGp(params)
      this.listTeam = res.data.data
      // let k = 0
      // let that = this
      // Object.getOwnPropertyNames(this.listTeam).forEach(function(key){
      //   that.listSeason.push(key)
      // })
      for(let key in this.listTeam){
        this.listSeason.push(key)
      }
      window.console.log(this.listSeason)
      let current = this.listSeason[0]
      window.console.log(this.listTeam[current])
      if(current){
        this.list = this.listTeam[current]
      }else{
        this.listSeason = []
        // window.console.log('nn');
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .m750{
    height: 100vh;
    // height: auto;
    overflow: hidden;
    background: #fff;
  }
  .navigation{
    width: 100%;
    height: .8rem;
    background: #E9001D;
    padding: .24rem .3rem;
    box-sizing: border-box;
    display: flex;
    // justify-content: space-around;
    justify-content: flex-start;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    .nav_item{
      font-size: .24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      min-width: 1.72rem;
      text-align: center;
    }
    .nav_checked{
      font-size: .28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
    }
    .nav_none{
      display: none;
    }
  }
  .main{
    margin-top: .8rem;
    overflow: scroll;
    height: calc(100vh - .8rem);
    .item{
      width: 100%;
      height: auto;
      padding: 0 .3rem;
      box-sizing: border-box;
      .item_main{
        width: 100%;
        height: 1.76rem;
        padding: .24rem 0;
        border-bottom: .01rem solid rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .item_left{
          font-size: .36rem;
          font-family: BebasNeue;
          color: #999999;
          width: .4rem;
          height: .4rem;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .item_center{
          display: flex;
          justify-content: space-around;
          .item_people{
            width: 1.28rem;
            height: 1.28rem;
            display: block;
            margin-left: .06rem;
            border-radius: .1rem;
          }
          .item_news{
            width: 4.92rem;
            margin-left: .24rem;
            // display: flex;
            // justify-content: space-around;
            .news_top{
              display: flex;
              justify-content: space-between;
              height: .4rem;
              align-items: center;
              .name{
                font-size: .28rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 700;
                color: #333333;
                width: 3.82rem;
              }
              .enname{
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
              }
              .grade{
                font-size: .24rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                display: flex;
                height: .32rem;
                align-items: center;
                .fen{
                  font-weight: 700;
                  margin-left: .1rem;
                }
                // margin-left: .3rem;
              }
            }
            .news_center{
              margin-top: .16rem;
              height: .32rem;
              display: flex;
              align-items: center;
              // justify-content: ;
              .news_country{
                width: .48rem;
                height: .32rem;
                object-fit: cover;
                display: block;
              }
              .news_number{
                font-size: .24rem;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
                margin-left: .1rem;
              }
            }
            .news_bottom{
              font-size: .22rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              margin-top: .08rem;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              width: 4.92rem;
            }
          }
        }
      }
      .item_main:nth-of-type(1){
        .item_left{
          color: #D0021B;
        }
      }
      .item_main:nth-of-type(2){
        .item_left{
          color: #FF4A4A;
        }
      }
      .item_main:nth-of-type(3){
        .item_left{
          color: #F5A623;
        }
      }
      .noList{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        width: 2.71rem;
        height: 3.18rem;
        .nodata{
          width: 2.71rem;
          height: 2.64rem;
          display: block;
          
        }
        .nodata2{
          font-size: .28rem;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #666666;
          line-height: .4rem;
          text-align: center;
          margin-top: .14rem;
        }
      }
      .kong{
        height: .3rem;
      }
    }
  }
  .main2{
    margin-top: 0;
    height: 100vh;
  }
</style>